// deps
import styled, { DefaultTheme } from "styled-components";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// constants
import { RAIN_BG_COLOR } from "@cart-ui/constants";

const GROUP_CART_HEADER_HEIGHT = "116px";
const HOST_DELETE_PILL_WIDTH = "48px";
const NON_HOST_LEAVE_GROUP_PILL_WIDTH = "108px";
const PILL_HEIGHT = "32px";
const HEADER_SUBTITLE_GAP = "2px";

interface IStyles {
    theme: DefaultTheme;
    backgroundColor?: string;
    isHost?: boolean;
}

export const Container = styled.div(({ theme }) => {
    return {
        height: GROUP_CART_HEADER_HEIGHT,
        borderRadius: `0 0 ${theme.spacing.medium} ${theme.spacing.medium}`,
        background: theme.colors[theme.colorMode].background_Primary,
        padding: theme.spacing.medium,
        width: "100%",
        top: "0",
        zIndex: "1",
    };
});

export const TopContainer = styled.div(() => {
    return {
        display: "flex",
        alignItems: "center",
    };
});

export const TitleContainer = styled.div(({ theme }) => {
    return {
        display: "flex",
        flexDirection: "column",
        maxWidth: `calc(100% - 2 * ${theme.spacing.medium})`,
        marginLeft: theme.spacing.small,
    };
});

export const Pill = styled.div<IStyles>(({ theme, backgroundColor, isHost }) => {
    let bgColor;

    if (backgroundColor === RAIN_BG_COLOR) {
        bgColor = theme.colors[theme.colorMode].rain_Sub;
    } else {
        bgColor = theme.colors[theme.colorMode].background_Secondary;
    }

    return {
        width: isHost ? HOST_DELETE_PILL_WIDTH : NON_HOST_LEAVE_GROUP_PILL_WIDTH,
        height: PILL_HEIGHT,
        borderRadius: `calc(${theme.spacing.medium} + ${theme.spacing.xxxSmall})`,
        background: bgColor,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginRight: `calc(${theme.spacing.xxSmall} + ${theme.spacing.xxxSmall})`,
        whiteSpace: "nowrap",
        paddingLeft: theme.spacing.xSmall,
        paddingRight: theme.spacing.xSmall,
    };
});

export const PillsContainer = styled.div(({ theme }) => {
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        margin: `calc(${theme.spacing.small} + ${theme.spacing.xxxSmall}) 0 0 calc(${theme.spacing.xxLarge} + ${theme.spacing.xxxSmall})`,
    };
});

export const IconContainer = styled.div(() => {
    return {
        height: "100%",
        display: "flex",
        alignItems: "center",
    };
});

export const TextWrapper = styled(Text)(({ theme }) => {
    return {
        marginLeft: theme.spacing.xxSmall,
        height: "100%",
        display: "flex",
        alignItems: "center",
    };
});

export const RestaurantNameText = styled(Text)(() => {
    return {
        overflow: "hidden",
        textOverflow: "ellipsis",
        outline: 0,
        whiteSpace: "nowrap",
        marginTop: HEADER_SUBTITLE_GAP,
    };
});
